/**
 * Card — shared card surface primitive.
 *
 * Provides the standard border / background / shadow / radius shell that
 * ResultCard, CoachCard (in SchoolDetailPage), and WatchlistCard all share.
 *
 * Design system tokens:
 *   - surfaceCard (bg-white), borderSubtle (border-gray-200),
 *     shadowCard (shadow-sm → shadow-md on hover), radiusMd (rounded-lg)
 *
 * Motion: hover shadow transition uses motion-safe: prefix.
 *
 * No Radix dependency.
 */

import React from 'react';

interface Props {
  /** Semantic element — article for list items, div for layout cards. */
  as?: 'article' | 'div' | 'section';
  children: React.ReactNode;
  className?: string;
  /** Additional aria attributes forwarded to the root element. */
  [key: `aria-${string}`]: string | undefined;
}

export function Card({ as: Tag = 'div', children, className = '', ...rest }: Props) {
  return (
    <Tag
      className={`border border-gray-200 rounded-lg bg-white shadow-sm motion-safe:hover:shadow-md motion-safe:transition-shadow ${className}`}
      {...rest}
    >
      {children}
    </Tag>
  );
}
